import axios from 'axios';
import { store } from '../store/store';
import { baseURL } from '../credential.js';
const axiosInstance = axios.create({
    baseURL
});

axiosInstance.interceptors.request.use((config) => {
    const state = store.getState();
    const token = state.auth.auth.idToken;
    config.params = config.params || {};
    config.params['auth'] = token;
    return config;
});

export default axiosInstance;
